import { useWindowDimensions } from 'react-native'

/**
 * Where the layout splits into the desktop shell. The same number as Tailwind's `lg:`, so a
 * JavaScript branch and a `lg:` class never disagree about which side of the line a width is on.
 */
export const DESKTOP_MIN_WIDTH = 1024

export const isDesktopWidth = (width: number) => width >= DESKTOP_MIN_WIDTH

export const useIsDesktop = () => isDesktopWidth(useWindowDimensions().width)
